<template>
  <input
    :value="modelValue"
    type="text"
    class="survey-question-text"
    :placeholder="question.placeholder ?? question.question"
    @input="onChange($event.target.value)"
  />
</template>

<script>
export default {
  name: "SurveyQuestionText",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    question: {
      type: Object,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_survey.scss";

.survey-question-text {
  @extend %survey-question-control;
  padding: 12px 10px;

  &::placeholder {
    color: #c0c0c0;
  }
}
</style>
